import React, { useState, useEffect } from 'react';
import deviceService from '../../services/deviceService';
import './OfflineWarning.css';

function OfflineWarning() {
  const [showWarning, setShowWarning] = useState(false);
  const [daysRemaining, setDaysRemaining] = useState(0);

  useEffect(() => {
    checkOfflineStatus();
    
    // Check every hour
    const interval = setInterval(checkOfflineStatus, 60 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  function checkOfflineStatus() {
    if (!deviceService.isRegistered()) return;

    const days = deviceService.getDaysUntilCheckin();
    setDaysRemaining(days);

    // Show warning if less than 3 days remaining
    if (days <= 3 && days > 0) {
      setShowWarning(true);
    } else if (days === 0) {
      setShowWarning(true);
    } else {
      setShowWarning(false);
    }
  }

  if (!showWarning) return null;

  return (
    <div className="offline-warning">
      <div className="warning-icon">⚠️</div>
      <div className="warning-content">
        {daysRemaining > 0 ? (
          <>
            <strong>Connect to Internet Soon</strong>
            <p>App will lock in {daysRemaining} day{daysRemaining !== 1 ? 's' : ''} without internet connection</p>
          </>
        ) : (
          <>
            <strong>Internet Connection Required</strong>
            <p>Please connect to internet to continue using the app</p>
          </>
        )}
      </div>
      <button onClick={() => setShowWarning(false)} className="warning-close">×</button>
    </div>
  );
}

export default OfflineWarning;
